(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/aria-utils/assets/javascripts/live-region-announcer.js') >= 0) return;  svs.modules.push('/components/pool-betting/aria-utils/assets/javascripts/live-region-announcer.js');
"use strict";


const {
  useState,
  useEffect
} = React;
const {
  useSelector
} = ReactRedux;
const {
  selectMaskedOutcomes
} = svs.components.tipsen.store.reducers.resultModifier.selectors;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  useCountdown
} = svs.components.poolBetting.hooks;
const {
  useBestBetRows
} = svs.components.poolBetting.bestBetRows.hooks;
function composeLiveMessage(_ref) {
  let {
    draw,
    isStarted,
    isCancelled,
    isLive,
    isFinalized,
    countDownString,
    hasMaskedOutcomes,
    maskedOutcomes,
    currentWinCount,
    formatDate
  } = _ref;
  if (!draw) {
    return '';
  }
  if (!isStarted && !isCancelled) {
    const regCloseInfo = countDownString || draw.regCloseTime;
    const date = new Date(regCloseInfo);
    const isValidDate = !isNaN(date);
    const renderDate = isValidDate ? formatDate(regCloseInfo, true, true, false) : regCloseInfo;
    return countDownString ? "Omg\xE5ng startar om ".concat(renderDate) : "Omg\xE5ng startar ".concat(renderDate);
  }
  if (isLive) {
    if (hasMaskedOutcomes) {
      return "Omg\xE5ng p\xE5g\xE5r, r\xE4ttningsupplevelse p\xE5: ".concat(maskedOutcomes.length, " resultat \xE4r dolda, Resultat just nu: ").concat(currentWinCount, " r\xE4tt");
    }
    return "Omg\xE5ng p\xE5g\xE5r, resultat just nu: ".concat(currentWinCount, " r\xE4tt");
  }
  if (isFinalized) {
    if (hasMaskedOutcomes) {
      return "Omg\xE5ng avslutad, r\xE4ttningsupplevelse p\xE5: ".concat(maskedOutcomes.length, " resultat \xE4r dolda, Resultat just nu: ").concat(currentWinCount, " r\xE4tt");
    }
    return "Omg\xE5ng avslutad, resultat: ".concat(currentWinCount, " r\xE4tt");
  }
  return '';
}
const LiveRegionAnnouncer = _ref2 => {
  let {
    draw,
    isStarted,
    isCancelled,
    isLive,
    isFinalized,
    wagerId
  } = _ref2;
  const [liveMessage, setLiveMessage] = useState('');
  const {
    hasUnmaskedOutcomes,
    hasMaskedOutcomes,
    getBestBetRows
  } = useBestBetRows();
  const {
    correctEventCount
  } = getBestBetRows();
  const countDownString = useCountdown({
    targetDateTime: draw === null || draw === void 0 ? void 0 : draw.cancelCloseTime
  });
  const maskedOutcomes = useSelector(state => selectMaskedOutcomes(state, wagerId));
  const hasAllOutcomesMasked = hasMaskedOutcomes && !hasUnmaskedOutcomes;
  const currentWinCount = hasAllOutcomesMasked ? '-' : correctEventCount;
  useEffect(() => {
    setLiveMessage(composeLiveMessage({
      draw,
      isStarted,
      isCancelled,
      isLive,
      isFinalized,
      countDownString,
      hasMaskedOutcomes,
      maskedOutcomes,
      currentWinCount,
      formatDate
    }));
  }, [isStarted, isCancelled, countDownString, draw, isLive, isFinalized, hasMaskedOutcomes, maskedOutcomes, currentWinCount]);
  return React.createElement("div", {
    "aria-live": "assertive",
    className: "sr-only"
  }, liveMessage);
};
setGlobal('svs.components.poolBetting.ariaUtils.LiveRegionAnnouncer', LiveRegionAnnouncer);

 })(window);